/* src/app/coupons/coupon-stats/coupon-stats.component.css */
.title-icon {
  vertical-align: middle;
  margin-right: 8px;
  color: #e91e63;
}
.usage-section {
  padding: 16px 0;
}
.usage-header {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
}
.usage-note {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
  margin-top: 4px;
}
.used-by-section {
  margin-top: 8px;
}
.used-by-section h4 {
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
}
.no-uses {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(0, 0, 0, 0.54);
  font-style: italic;
  padding: 16px 0;
}
mat-dialog-content {
  min-width: 400px;
}
/*# sourceMappingURL=coupon-stats.component.css.map */
